import { MenuRoute } from '../../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the FixedAsset Control Panel sub-module.
 */
export const FIXED_ASSET_CONTROL_PANEL_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/fixed-asset/control-panel',
    labelKey: 'FixedAsset.controlPanel',
    icon: '/assets/tablerIcons/outline/settings.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetConfig',
    requiresAdmin: true
  }
];
